<template>
  <!--<div>-->
  <!--{{cacheList}}-->
  <l-slide-y-enter-transition>
    <keep-alive>
      <router-view/>
    </keep-alive>
  </l-slide-y-enter-transition>
  <!--</div>-->
</template>
<script>
import LSlideYEnterTransition from '../LSlideYEnterTransition/LSlideYEnterTransition'

export default {
  name: 'LParentView',
  components: {LSlideYEnterTransition},
  props: {
    include: {},
    cacheAll: {
      type: Boolean,
      default: false
    }
  }
}
</script>
